import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsNotificationModalOpen } from "../slices/chat/reducer";
import { getNotificationThunk } from "../slices/chat/thunk";
import notificationIcon from "images/notification-icon.svg";

const NotificationModal = () => {
  const dispatch = useDispatch();
  const { isNotificationModalOpen, notifications } = useSelector(
    (state) => state.ChatReducer
  );

  const [expanded, setExpanded] = useState({});

  //   useEffect(() => {
  //     if (isNotificationModalOpen) {
  //       dispatch(getNotificationThunk());
  //     }
  //   }, [isNotificationModalOpen, dispatch]);

  const closeModal = () => {
    dispatch(setIsNotificationModalOpen(false));
  };

  const toggleExpand = (index) => {
    setExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  if (!isNotificationModalOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-[#0F172A] rounded-lg shadow-lg w-full max-w-md p-6">
        <div className="mb-4">
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-semibold text-white">Notification</h2>
            <button onClick={closeModal} className="text-white text-xl">
              ×
            </button>
          </div>
          <div className="mt-2 h-px w-full bg-[#334155]" />
        </div>

        <div className="h-96 overflow-y-scroll overflow-x-hidden pr-2 custom-scroll">
          {notifications.length > 0 ? (
            <div className="space-y-6">
              {notifications.map((notification, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <img
                    src={notificationIcon}
                    alt="notification"
                    className="w-10 h-10 mt-1 flex-shrink-0"
                  />
                  <div className="text-sm text-white text-left leading-snug w-full">
                    <p className="text-xs text-gray-400 mb-1">
                      {notification.event}
                    </p>

                    <div
                      className={`font-medium ${
                        !expanded[index] ? "line-clamp-2" : ""
                      }`}
                      dangerouslySetInnerHTML={{
                        __html: notification.message
                          .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
                          .replace(
                            /Generated Form Link["']?\s*/g,
                            "Generated Form Link: "
                          )
                          .replace(/\\n/g, "") // removes literal \n
                          .replace(
                            /(https?:\/\/[^\s)]+)/g,
                            '<a href="$1" target="_blank" class="text-blue-400 underline">$1</a>'
                          ),
                      }}
                    />

                    {notification.message.length > 100 && (
                      <button
                        onClick={() => toggleExpand(index)}
                        className="text-xs text-blue-400 mt-1"
                      >
                        {expanded[index] ? "Read less" : "Read more"}
                      </button>
                    )}

                    <p className="text-xs text-gray-400 mt-1">
                      {notification.time}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-white text-sm">No notifications to display.</p>
          )}
        </div>
      </div>

      <style jsx>{`
        .custom-scroll::-webkit-scrollbar {
          display: none;
        }
        .custom-scroll {
          -ms-overflow-style: none; /* IE and Edge */
          scrollbar-width: none; /* Firefox */
        }
      `}</style>
    </div>
  );
};

export default NotificationModal;
